module.exports = __webpack_public_path__ + "img/brushstroke_divider.5ec503c0.png";